import React, { useRef } from 'react'
import styles from './styles.module.scss'
import Navigate from '../Navigate'
import { useTranslation } from 'react-i18next'
import PromptBlock from 'srcReact/MyProfile/components/MainContainer/components/PromptBlock'

function PromptList({ user, titleCSS, isMobile, isLoggedUser }) {
  const { t } = useTranslation()
  const promptRef = useRef()

  return (
    user?.prompts?.prompts?.length > 0 && (
      <Navigate
        titleCSS={titleCSS}
        itemRef={promptRef}
        totalItems={user.prompts.prompts.length}
        isMobile={isMobile}
        moveByPx={257}
        title={
          user.prompts.length === 1
            ? t('profile_light.prompt_title', {
                count: ` (${user.prompts.prompts.length})`,
                username: user?.first_name
              })
            : t('profile_light.prompt_title_plural', {
                count: ` (${user.prompts.prompts.length})`,
                username: user?.first_name
              })
        }>
        <PromptBlock block='lightProfile' user={user} promptContainerRef={promptRef} className={styles.promptWrapper} />
      </Navigate>
    )
  )
}

export default PromptList
